class MediaStorage {
   static instance = null;
   static dbName = 'MediaStorage';
   static storeName = 'mediaFiles';

   constructor() {
      MediaStorage.instance = this;
   }

   static async getInstance() {
      if (MediaStorage?.instance?.db) {
         return MediaStorage.instance;
      }

      const storage = new MediaStorage();
      storage.db = await storage._initDB();
      return storage;
   }

   async _initDB() {
      return new Promise((resolve, reject) => {
         const request = indexedDB.open(MediaStorage.dbName, 1);

         request.onupgradeneeded = event => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(MediaStorage.storeName)) {
               db.createObjectStore(MediaStorage.storeName, { keyPath: 'messageId' });
            }
         };

         request.onsuccess = () => resolve(request.result);
         request.onerror = () => reject('IndexedDB initialization failed');
      });
   }

   async save(messageId, blob) {
      const tx = this.db.transaction(MediaStorage.storeName, 'readwrite');
      const record = {
         messageId,
         blob,
         type: blob.type,
         size: blob.size,
         savedAt: Date.now(),
      };
      tx.objectStore(MediaStorage.storeName).put(record);
      return tx.complete || tx.done;
   }

   async get(messageId) {
      return new Promise(resolve => {
         const tx = this.db.transaction(MediaStorage.storeName, 'readonly');
         const req = tx.objectStore(MediaStorage.storeName).get(messageId);
         req.onsuccess = () => resolve(req.result || null);
         req.onerror = () => resolve(null);
      });
   }

   async delete(messageId) {
      const tx = this.db.transaction(MediaStorage.storeName, 'readwrite');
      tx.objectStore(MediaStorage.storeName).delete(messageId);
      return tx.complete || tx.done;
   }

   async listAll() {
      const tx = this.db.transaction(MediaStorage.storeName, 'readonly');
      const store = tx.objectStore(MediaStorage.storeName);

      return new Promise((resolve, reject) => {
         const items = [];
         const request = store.openCursor();
         request.onsuccess = e => {
            const cursor = e.target.result;
            if (cursor) {
               items.push(cursor.value);
               cursor.continue();
            } else {
               resolve(items);
            }
         };
         request.onerror = () => reject('Failed to list items');
      });
   }

   async clear() {
      const tx = this.db.transaction(MediaStorage.storeName, 'readwrite');
      tx.objectStore(MediaStorage.storeName).clear();
      return tx.complete || tx.done;
   }
}

const mediaStorage = await MediaStorage.getInstance();
export default mediaStorage;
